import { render, staticRenderFns } from "./ProfileExpansionPanel.vue?vue&type=template&id=3313cee3"
import script from "./ProfileExpansionPanel.vue?vue&type=script&lang=ts"
export * from "./ProfileExpansionPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports